import React from 'react';
import { Marker, Tooltip } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { fileUrl } from '@/lib/api';
import { makePinIcon, clusterIcon, IS_TOUCH } from '@/lib/mapIcons';

export default function PinMarkers({ pins, previewPinId, onMarkerTap }) {
  return (
    <MarkerClusterGroup
      chunkedLoading
      showCoverageOnHover={false}
      maxClusterRadius={60}
      spiderfyOnMaxZoom
      iconCreateFunction={clusterIcon}
    >
      {pins.map((p) => (
        <Marker
          key={p.id}
          position={[p.lat, p.lng]}
          icon={makePinIcon(p.category, p.title)}
          eventHandlers={{ click: () => onMarkerTap(p) }}
        >
          <Tooltip
            key={`${p.id}-${IS_TOUCH && previewPinId === p.id ? 'perm' : 'hover'}`}
            direction="top" offset={[0, -50]} opacity={1} className="curb-tooltip"
            permanent={IS_TOUCH && previewPinId === p.id}
          >
            <div className="flex gap-2 items-start" style={{ maxWidth: 240 }}>
              <img
                src={fileUrl(p.photos?.[0] || (p.category === 'yard_sale' ? 'default_yard_sale' : ''))}
                onError={(e) => { e.target.style.display = 'none'; }}
                alt=""
                style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 10, flexShrink: 0, background: '#eef0eb' }}
              />
              <div style={{ minWidth: 0 }}>
                <div className="font-display font-semibold text-sm text-brand-ink" style={{ lineHeight: 1.2 }}>{p.title}</div>
                <div className="text-[11px] text-brand-slate mt-0.5">
                  {new Date(p.starts_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })} → {new Date(p.ends_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
                </div>
                {p.category === 'yard_sale' && (
                  <div className="text-[11px] text-brand-slate">
                    {new Date(p.starts_at).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })}–{new Date(p.ends_at).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })}
                  </div>
                )}
                {IS_TOUCH && previewPinId === p.id && (
                  <div className="text-[10px] text-brand-dim mt-1">Tap again to open</div>
                )}
              </div>
            </div>
          </Tooltip>
        </Marker>
      ))}
    </MarkerClusterGroup>
  );
}
